module.exports = __webpack_public_path__ + "img/link.b1206ff9.svg";